export default {
  methods: {
    getSectionPath(bookId, sectionNumber, practiceMode) {
      switch (practiceMode) {
        case "Reading":
          return `/library/${bookId}/sections/${sectionNumber}?mode=r`;
        case "Dictation":
          return `/library/${bookId}/sections/${sectionNumber}?mode=d`;
        default:
          return `/library/${bookId}/sections/${sectionNumber}`;
      }
    }
  }
};
